export default __webpack_public_path__ + "static/media/bg-2.869d3e30.jpg";